import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import ModalContainer from "../modal/ModalContainer";
import StepsContainer from "../steps/StepsContainer";
import TabsContainer from "../tabs/TabsContainer";
import {
  TAB_BRIDGE_WIDGET,
  TAB_BUTTON_WIDGET,
  TAB_INLINE_WIDGET,
  TAB_MODAL_WIDGET,
  TAB_UPDATE_PI_WIDGET
} from "../tabs/TabsConstants";
import {getSelected} from "../tabs/TabsReducers";
import {getCurrent} from "../steps/StepsReducers";
import {setAppConfig} from "./AppActions";
import {getAppMode, getAppStatus} from "./AppReducers";
import {APP_MODE_DOCUMENTATION, APP_MODE_QA, APP_STATUS_NOT_CONFIGURED, APP_STATUS_READY} from "./AppConstants";
import SetupContainer from "../setup/SetupContainer";
import {STEP_CONFIGURE_WIDGET, STEP_CREATE_ORDER, STEP_RESULT, STEP_SETUP_ENVIRONMENT} from "../steps/StepsContants";
import BridgeContainer from "../bridge/BridgeContainer";
import InlineContainer from "../inline/InlineContainer";
import {getOrder} from "../order/OrderReducers";
import ResultContainer from "../result/ReesultContainer";
import OrderContainer from "../order/OrderContainer";
import { select, finish } from "../steps/StepsActions";
import {configure, loadBridge} from '../setup/SetupActions';
import UpdatePiContainer from "../update-pi/UpdatePiContainer";
import ModalsContainer from "../common/modals/ModalsContainer";
import ButtonContainer from "../button/ButtonContainer";

const App = ({selectedTab, currentStep, setAppConfig, status, mode, loadBridge, configure, order, select, finish}) => {

  const onConfigLoad = (result) => {
    if (result.environment.production) {
      loadBridge(result.environment, () => {
        setAppConfig(result, APP_MODE_DOCUMENTATION);
        configure(result.environment, result.environment, result.environment.merchantId);
      });
    } else {
      setAppConfig(result, APP_MODE_QA);
    }
  };

  const loadDefaultConfiguration = () => {
    if (status === APP_STATUS_NOT_CONFIGURED) {
      fetch("/config.json")
        .then(res => res.json())
        .then(onConfigLoad);
    }
  };

  const getContent = () => {
    if (status === APP_STATUS_NOT_CONFIGURED) {
      return 'Loading Configuration...';
    }

    if (status === APP_STATUS_READY || currentStep.key === STEP_SETUP_ENVIRONMENT) {
      if (mode === APP_MODE_QA) {
        return <SetupContainer/>;
      } else {
        return;
      }
    }

    if (currentStep.key === STEP_RESULT) {
      return <ResultContainer/>;
    }

    if (selectedTab === TAB_BRIDGE_WIDGET || selectedTab === TAB_UPDATE_PI_WIDGET) {
      if (currentStep.key === STEP_CREATE_ORDER) {
        finish();
        select(STEP_CONFIGURE_WIDGET);
      }
      return selectedTab === TAB_BRIDGE_WIDGET ? <BridgeContainer/> : <UpdatePiContainer/>;
    }

    if (currentStep.key === STEP_CREATE_ORDER) {
      return <OrderContainer/>
    }

    if (!order) {
      select(STEP_CREATE_ORDER);
      return <OrderContainer/>;
    }

    if (selectedTab === TAB_MODAL_WIDGET) {
      return <ModalContainer/>;
    }

    if (selectedTab === TAB_INLINE_WIDGET) {
      return <InlineContainer/>;
    }

    if (selectedTab === TAB_UPDATE_PI_WIDGET) {
      return <UpdatePiContainer/>;
    }

    if (selectedTab === TAB_BUTTON_WIDGET) {
      return <ButtonContainer/>;
    }

    return '';
  };

  const setBodySmall = (width, isInitial) => {
    const isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
    const compareWidthInit = isSafari ? 783 : 768;
    const compareWidthResize = isSafari ? 768 : 753;
    const compareWidth = isInitial ? compareWidthInit : compareWidthResize;

    if (width < compareWidth) {
      document.body.classList.add('page-small');
    } else {
      document.body.classList.remove('page-small');
      document.body.classList.remove('show-sidebar');
    }
  };

  loadDefaultConfiguration();
  setBodySmall(window.innerWidth, true);

  window.addEventListener('resize', () => {
    setBodySmall(window.innerWidth, false);
  });

  return (
    <div>
      <header>
        <div id="header">
          <div className="light-version" id="logo">
            <img alt="Logo" src={require('../images/logo.png')} />
          </div>
          <StepsContainer/>
        </div>
      </header>
      <nav>
        <TabsContainer/>
      </nav>
      <div id="wrapper">
        <div className="content">
          <div className="row">
            <div className="hpanel">
              <div className="panel-heading">
                <div className="row vertical-align">
                  <div className="col-xs-8">
                    <h1 className="page-title">{currentStep.value}</h1>
                  </div>
                </div>
              </div>
              <div className="panel-body">
                <ModalsContainer/>
                {getContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

App.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  setAppConfig: PropTypes.func
};

const mapStateToProps = (state) => ({
  selectedTab: getSelected(state),
  currentStep: getCurrent(state),
  status: getAppStatus(state),
  mode: getAppMode(state),
  order: getOrder(state)
});

export default connect(
  mapStateToProps,
  {setAppConfig, select, finish, loadBridge, configure}
)(App);



// WEBPACK FOOTER //
// ./src/app/App.js